var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "address-validation" } },
    [
      _c("b-row", { attrs: { "no-gutters": "" } }, [
        _c("h1", { staticClass: "mb-0" }, [
          _c("strong", [
            _vm._v(_vm._s(_vm.$t("xAddressSearchVerifyAddressModalHeader")))
          ])
        ])
      ]),
      _c("b-row", { staticClass: "mb-2", attrs: { "no-gutters": "" } }, [
        _c("p", [_vm._v(" " + _vm._s(_vm.modalDescriptionText) + " ")])
      ]),
      _vm.submittedAddress
        ? _c(
            "b-row",
            [
              _c(
                "b-card",
                {
                  staticClass: "w-100 mx-3",
                  attrs: { title: _vm.$t("xAddressSearchProvidedAddress") }
                },
                [
                  _c(
                    "div",
                    { staticClass: "address-with-icon" },
                    [
                      _c("i", {
                        staticClass:
                          "fa-regular fa-triangle-exclamation alertIcon"
                      }),
                      _c("b-card-text", { staticClass: "address-spacing" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              `${_vm.submittedAddress.address1} ${_vm
                                .submittedAddress.address2 ?? ""}`.trim()
                            )
                          )
                        ]),
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                `${_vm.submittedAddress.city}, ${_vm.submittedAddress.state} ${_vm.submittedAddress.postalCode}`.trim()
                              ) +
                              " "
                          )
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.submittedAddress.country))
                        ])
                      ])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.shouldShowInvalidAddressScreen
        ? _c(
            "b-row",
            [
              _c(
                "b-card",
                {
                  staticClass: "w-100 mx-3 mt-2",
                  attrs: {
                    title: _vm.$t("xAddressSearchRecommendedAddressSingle")
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "address-with-icon" },
                    [
                      _c("i", {
                        staticClass:
                          "fa-regular fa-triangle-exclamation alertIcon"
                      }),
                      _c("b-card-text", { staticClass: "address-spacing" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("xAddressNoRecommendedAddressFound")
                            ) +
                            " "
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.validateAddressResponse &&
      _vm.validateAddressResponse.suggestionList &&
      !_vm.shouldShowInvalidAddressScreen
        ? _c(
            "b-row",
            [
              _c(
                "b-card",
                {
                  staticClass: "w-100 mx-3 mt-2",
                  attrs: { title: _vm.recommendedAddressLabel }
                },
                [
                  _c("b-form-radio-group", {
                    staticClass: "gap-4",
                    attrs: {
                      options: _vm.addressOptions,
                      name: "address-options",
                      stacked: ""
                    },
                    model: {
                      value: _vm.selectedAddress,
                      callback: function($$v) {
                        _vm.selectedAddress = $$v
                      },
                      expression: "selectedAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }